import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LangSwitcher } from '@/lib/i18n';
import { Page } from './Page';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Page />
  </StrictMode>
);

const langMount = document.getElementById('lang-mount');
if (langMount) {
  createRoot(langMount).render(
    <StrictMode>
      <LangSwitcher />
    </StrictMode>
  );
}
